var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFurnitureSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-40v-880h66.666v80h586.668v-80H840v880h-66.666v-80H186.666v80H120Zm66.666-472.666h100.001v-160h226.666v160h260.001v-260.668H186.666v260.668Zm0 326h260.001v-160h226.666v160h100.001V-446H186.666v259.334Zm166.667-326h93.334V-606h-93.334v93.334Zm160 326h93.334V-280h-93.334v93.334Zm-160-326h93.334-93.334Zm160 326h93.334-93.334Z",
    fill: "#5D616D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnitureSetup);
export default __webpack_public_path__ + "static/media/Furniture Setup.03bde0bcc8df5c50bc572fcb6789bccd.svg";
export { ForwardRef as ReactComponent };